<template>
  <div class="login-screen">
    <div class="login-card d-flex flex-column align-items-center gap-3">
      <BrandMark :size="64" />
      <div>
        <h1 class="h3 mb-1">Willkommen zurück!</h1>
        <p class="text-body-secondary mb-0">Verwaltung der DSV Skischule Heilbronn-Unterland</p>
      </div>
      <button type="button" class="btn btn-primary btn-lg w-100 mt-2" @click="login">Anmelden</button>
    </div>
  </div>
</template>

<script setup>
import BrandMark from "@/components/frame/BrandMark.vue";
import { AuthenticationContext } from "@/auth/msal-context";

defineOptions({ name: "LoginComponent" });

const login = () => AuthenticationContext.login();
</script>
